import React from 'react'
import Benefits from '../components/molecules/benefits/benefits'
import Header from '../components/molecules/header/header'
import Banner from '../components/molecules/banner/banner'
import TechNight from '../components/molecules/techNight/techNight'
import HowUsed from '../components/molecules/how-used/how-used'
import Competition from '../components/molecules/competition/competition'
import Footer from '../components/molecules/footer/footer'
import './../styles/index.scss'
import Faqs from '../components/molecules/faqs/faqs'
import Experience360 from '../components/molecules/experience360/experience360'

function IndexPage() {
  return (
    <>
      <Header />
      <Banner />
      {['es-CO'].includes(process.env.LOCALE) && <Competition />}
      <Benefits />
      <HowUsed />
      <TechNight />
      {/* <Experience360 /> */}
      <Faqs />
      <Footer />
    </>
  )
}

export default IndexPage
